module.exports = __webpack_public_path__ + "static/img/Contact.fc9eff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Contact.png
// module id = bjAZ
// module chunks = 1